import React from 'react';
import { SchematicShell, ToeKickLine } from './SchematicPrimitives';

/**
 * Blank panel — decorative cabinetry filler used between cabinets, at
 * an island end, or at a single-sided corner cabinet's near side. The
 * elevation reads as a continuation of cabinet faces with NO door /
 * drawer split lines (suppressing those is the entire point — the
 * panel exists to look like cabinetry without being a real cabinet).
 *
 * Frame + toe-kick. Counter-height blank panels (`buildBlankPanel.js`
 * uses KITCHEN_CABINET_DIMENSIONS.height) keep the toe-kick; tall or
 * upper-height variants don't, so suppress the kick when the panel is
 * taller than typical cabinet height or shorter than the kick itself.
 *
 * Side views: thin (~24") panel — a depth×height rectangle with the
 * same toe-kick rule. Smooth front. Symmetric left ↔ right.
 *
 * A plain slab (`dimensions.plainSlab` — the header panel over a fridge,
 * `cabinet-runs/fridgeHeader.js`) has no toe-kick at any height, as the 3D
 * panel draws it.
 */

const KICK_HEIGHT_M = 4 * 0.0254;
const TYPICAL_LOWER_CABINET_H_M = 36 * 0.0254;

export function BlankPanelSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  obj = {},
  strokeColor,
  strokeWidth,
}) {
  const isSide = view === 'left' || view === 'right';
  const w = isSide ? depth : width;
  const showKick =
    obj.dimensions?.plainSlab !== true &&
    height >= KICK_HEIGHT_M * 2 &&
    height <= TYPICAL_LOWER_CABINET_H_M * 1.2;
  return (
    <SchematicShell
      width={w}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {showKick && (
        <ToeKickLine
          width={w}
          height={height}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
      )}
    </SchematicShell>
  );
}
BlankPanelSchematic.supportsSideViews = true;
// A blank panel has no front: the same frame and kick face both ways.
BlankPanelSchematic.supportsBackView = true;
